import React from 'react';
import { NotificationI } from '../../../types';
import './Notifications.scss';
import { NotificationGeneral } from './NotificationGeneral';
import { NotificationApproval } from './NotificationApproval';
import { NotificationView } from './NotificationView';
import { NotificationCancelled } from './NotificationCancelled';
import { NotificationHtml } from './NotificationHtml';

interface PropsI {
  message: NotificationI
  deleteNotif: (msgId: number) => void,
  onClose: () => void,
}

export const Notifications = (props: PropsI) => {
  const {message, onClose , deleteNotif} = props;

  return (
    <div key={message.id} className={'notification'}>
      {(message.notificationType === 'ACTING' || message.notificationType ===  'VACATION_SETTINGS' || message.notificationType ===  'CALENDAR_REMINDER') && <NotificationHtml message={message}/>}
      {(message.notificationType === 'GENERAL' ||  message.notificationType === 'CREATION') && <NotificationGeneral isCreated={message.notificationType === 'CREATION'} message={message} deleteNotif={deleteNotif} onClose={onClose}/>}
      {message.notificationType === 'APPROVAL' && <NotificationApproval message={message} deleteNotif={deleteNotif} onClose={onClose}/>}
      {message.notificationType === 'VIEWING'  && <NotificationView message={message} deleteNotif={deleteNotif} onClose={onClose}/>}
      {message.notificationType === 'CANCELLED' && <NotificationCancelled message={message} deleteNotif={deleteNotif} onClose={onClose}/>}
    </div>
  );
};
